export const validationRegex = {
  // price
  // e.g. 0, 0.00, 0.02, 0.22, 1, 1.11, 100, 100.11, 1000, 1000.11, 200000, 200000.44
  price: /^(0|[1-9]\d*)(\.\d{2})?$/,

  // integer allows only positive digits, without special characters
  // e.g. 1, 10, 100, 1000
  // it works for input type="text"
  integer: /^\d+$/,

  // percentage allows 1-3 digits, optionally followed by a decimal and 4 more digits
  // e.g. 1, 1.1, 1.11, 100, 100.1, 100.11 1000, 1000.1, 1000.11, 1000.111, 1000.1111
  percentage: /^(?:\d{1,3}(?:\.\d{1,3})?)$/,

  // hexColor allows 3 or 6 characters, preceded by a hash
  hexColor: /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/,

  // sixDigitHexColor allows 6 characters, preceded by a hash
  sixDigitHexColor: /^#([A-F0-9]{6})$/,

  // validate if #{receipt_uri} string is included in text
  receiptUri: /#{receipt_uri}/,
}

export const errorMessages = {
  price:
    'Please enter a valid price. The price must be a number with up to two decimal places.',
  integer: 'Please enter a valid number without special characters',
  percentage:
    'Please enter a valid tax percentage up to three decimal places.',
  hexColor: 'The value you entered is not a valid hex color.',
  receiptUri:
    '#{receipt_uri} must be included in the SMS Receipt Message. Please edit and save again.',
}
